// Embroidery Modal Functions
const UPPERCASE_FONT_TYPES = new Set(['circle']);
const SECOND_LETTER_UPPERCASE_FONT_TYPES = new Set(['fancy']);
let embroideryRawInputValue = '';
let embroideryDisplayedValue = '';

function getSelectedFontType() {
  return document.querySelector('input[name="font-type"]:checked')?.value || '';
}

function selectedFontRequiresUppercase() {
  return UPPERCASE_FONT_TYPES.has(getSelectedFontType());
}

function selectedFontRequiresSecondLetterUppercase() {
  return SECOND_LETTER_UPPERCASE_FONT_TYPES.has(getSelectedFontType());
}

function updateTextInputFontClass() {
  const textInput = document.getElementById('embroidery-text-input');
  if (!textInput) return;

  const fontInputs = document.querySelectorAll('input[name="font-type"]');
  fontInputs.forEach((input) => textInput.classList.remove(input.value));

  if (!textInput.value.trim()) {
    return;
  }

  const selectedFont = getSelectedFontType();
  if (selectedFont) {
    textInput.classList.add(selectedFont);
  }
}

window.openEmbroideryModal = function() {
  document.getElementById('embroidery-modal').style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Update preview positioning based on coordinates
  // const previewText = document.getElementById('embroidery-preview-text');
  // if (previewText) {
  //   // Get coordinates from data attributes or inline styles
  //   const yCoord = '17%';
  //   const xCoord = previewText.style.left || '50%';    
    
  //   previewText.style.top = yCoord;
  //   previewText.style.left = xCoord;    
  // }
}

window.closeEmbroideryModal = function() {
  document.getElementById('embroidery-modal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

window.resetEmbroideryForm = function() {
  // Reset text input
  const textInput = document.getElementById('embroidery-text-input');
  if (textInput) {
    textInput.value = '';
    embroideryRawInputValue = '';
    embroideryDisplayedValue = '';
  }
  
  // Reset to first font option
  const firstFont = document.querySelector('input[name="font-type"]');
  if (firstFont) {
    firstFont.checked = true;
  }

  updateTextInputFontClass();
  
  // Reset to first size option
  const firstSize = document.querySelector('input[name="embroidery-size"]');
  if (firstSize) {
    firstSize.checked = true;
  }
  
  // Reset to first color option
  const firstColor = document.querySelector('input[name="text-color"]');
  if (firstColor) {
    firstColor.checked = true;
  }
  
  // Update preview and character count
  updatePreview();
  updateCharacterCount();
  updateAddButton();
}

function updatePreview() {
  const textInput = document.getElementById('embroidery-text-input');
  const fontType = document.querySelector('input[name="font-type"]:checked')?.value || 'ariel-block';
  const textColor = document.querySelector('input[name="text-color"]:checked')?.value || 'pink';
  const embroiderySize = document.querySelector('input[name="embroidery-size"]:checked')?.value || '1';
  const embroiderySizeMultiplier = document.querySelector('input[name="embroidery-size"]:checked')?.dataset?.multiplier || '1';
  const previewText = document.getElementById('embroidery-preview-text');

  if (previewText) {
    if(fontType == 'circle') {
      const textInputValue = textInput?.value;
      const firstLetter =  textInputValue.charAt(0);
      const middleLetter =  textInputValue.slice(1, textInputValue.length - 1);
      const lastLetter =  textInputValue.charAt(textInputValue.length - 1);
      previewText.innerHTML = `<span style="font-family: 'Circle Monogram First'">${firstLetter}</span>
      <span style="font-family: 'Circle Monogram Middle'">${middleLetter}</span>
      <span style="font-family: 'Circle Monogram Last'">${lastLetter}</span>`      
    }
    else {
      previewText.textContent = textInput?.value || '';
    }
    previewText.className = `embroidery-preview-text ${fontType} ${embroiderySize}`;
    previewText.style.color = getColorValue(textColor);
    
    // Update font size based on selection
    //const sizeMultiplier = getSizeMultiplier(embroiderySize);
    const sizeMultiplier = Number(embroiderySizeMultiplier);
    previewText.style.fontSize = (14 * sizeMultiplier) + 'px';
    //previewText.style.transform = `scale(${sizeMultiplier})`;
    //console.log('sizeMultiplier', sizeMultiplier, previewText.style.fontSize);
  }
  
  // Update selected labels
  // const selectedFont = document.getElementById('selected-font');
  const selectedColor = document.getElementById('selected-color');
  const selectedSize = document.getElementById('selected-size');
  
  // if (selectedFont) {
  //   selectedFont.textContent = formatFontName(fontType);
  // }
  if (selectedColor) {
    selectedColor.textContent = textColor.charAt(0).toUpperCase() + textColor.slice(1);
  }
  if (selectedSize) {
    selectedSize.textContent = embroiderySize + '"';
  }
}

function getColorValue(color) {
  const colors = {
    pink: '#FFB9CB',
    light_blue: '#89AABC',
    green: '#384E3A',
    red: '#9D3530',
    white: '#D4C9B2',
    navy: '#1C2833'
  };
  return colors[color.replace('-', '_')] || '#FFB9CB';
}

// function getSizeMultiplier(size) {
//   const multipliers = {
//     '1': 1,
//     '2': 1.5,
//     '3/4': 0.75,
//     '2-height': 1.5,
//     '3/4-height': 0.75,
//     '3 1/4': 2,
//     'large-3-in-height': 2,
//     'small-2-in-height': 1.5
//   };
//   return multipliers[size] || 1;
// }

function formatFontName(fontType) {
  const fontNames = {
    'ariel': 'Ariel Block',
    'fancy': 'Fancy Monogram',
    'circle': 'Circle Monogram',
    'chain-stitch': 'Chain Stitch'
  };
  return fontNames[fontType] || fontType;
}

function formatFontForProperties(fontType) {
  const fontMapping = {
    'ariel': 'arial',
    'fancy': 'fancy',
    'circle': 'circle',
    'chain': 'chain'
  };
  return fontMapping[fontType] || fontType.replace('-', '_');
}

function formatColorForProperties(colorType) {
  const colorMapping = {
    'pink': 'Pink',
    'light_blue': 'Light Blue',
    'light-blue': 'Light Blue',
    'green': 'Green',
    'red': 'Red',
    'white': 'White',
    'navy': 'Navy'
  };
  return colorMapping[colorType] || colorType.charAt(0).toUpperCase() + colorType.slice(1);
}

function updateCharacterCount() {
  const textInput = document.getElementById('embroidery-text-input');
  const countElement = document.getElementById('character-count');
  
  if (textInput && countElement) {
    const count = textInput.value.length;
    const maxLength = textInput.getAttribute('maxlength') || '10';
    countElement.textContent = `${count}/${maxLength}`;
  }
}

function updateAddButton() {
  const textInput = document.getElementById('embroidery-text-input');
  const addBtn = document.getElementById('embroidery-add-btn');
  
  if (textInput && addBtn) {
    addBtn.disabled = textInput.value.trim().length === 0;
  }
}

window.addEmbroideryToCart = function() {
  const textInput = document.getElementById('embroidery-text-input');
  const fontType = document.querySelector('input[name="font-type"]:checked')?.value || 'ariel-block';
  const textColor = document.querySelector('input[name="text-color"]:checked')?.value || 'pink';
  const embroiderySize = document.querySelector('input[name="embroidery-size"]:checked')?.value || '1';
  
  // Get embroidery details
  const embroideryText = textInput?.value.trim() || '';
  const font = formatFontForProperties(fontType);
  const fontSize = embroiderySize + '"';
  const location = 'chest_upper_center';
  const color = formatColorForProperties(textColor);
  
  // Create embroidery data object
  const embroideryData = {
    text: embroideryText,
    font: font,
    size: embroiderySize,
    font_size: fontSize,
    location: location,
    color: color,
    shippingNote: getShippingNote()
  };
  
  // Add embroidery as line item property to main product
  addEmbroideryToMainProduct(embroideryData);
  
  // Add embroidery product to cart
  
  
  // Close modal
  closeEmbroideryModal();
  
  // Update display to show selected embroidery options
  updateEmbroideryDisplay(embroideryData);
  
  // Toggle add to cart buttons
  toggleAddToCartButtons();
  
  // Update preview text in selected state
  const selectedPreview = document.getElementById('embroidery-preview-text-selected');
  if (selectedPreview) {
    if(fontType == 'circle') {
      const textInputValue = textInput?.value;
      const firstLetter =  textInputValue.charAt(0);
      const middleLetter =  textInputValue.slice(1, textInputValue.length - 1);
      const lastLetter =  textInputValue.charAt(textInputValue.length - 1);
      selectedPreview.innerHTML = `<span style="font-family: 'Circle Monogram First'">${firstLetter}</span>
      <span style="font-family: 'Circle Monogram Middle'">${middleLetter}</span>
      <span style="font-family: 'Circle Monogram Last'">${lastLetter}</span>`
    }
    else {
      selectedPreview.textContent = embroideryText;
    }
    selectedPreview.style.color = getColorValue(textColor);
    selectedPreview.style.fontFamily = getFontFamily(fontType);
  }
}

function getShippingNote() {
  // This would typically come from block settings
  return 'Embroidered items are FINAL SALE. Orders with embroidered items will allow up to 2 additional weeks to ship.';
}

function getFontFamily(fontType) {
  const fontFamilies = {
    'ariel': 'Ariel Block',
    'fancy': 'Fancy Monogram',
    'circle': 'Circle Monogram',
    'chain': 'Chain Stitch'
  };
  return fontFamilies[fontType] || 'Ariel Block, sans-serif';
}

function addEmbroideryToMainProduct(embroideryData) {
  // Find the embroidery properties input
  // const embroideryInput = document.getElementById('embroidery-properties');
  const embroideryEnabled = document.getElementById('embroidery-enabled');
  // const embroideryText = document.getElementById('embroidery-text');
  // const embroideryFont = document.getElementById('embroidery-font');
  // const embroiderySize = document.getElementById('embroidery-size');
  // const embroideryColor = document.getElementById('embroidery-color');
  // const embroideryLocation = document.getElementById('embroidery-location');
  if (!embroideryEnabled) {
    console.error('Embroidery properties input not found');
    return;
  }
  let embroideryDataSize = embroideryData.size;
  if (embroideryData.size.includes('small')) {
    embroideryDataSize = 'S'
  } else if (embroideryData.size.includes('large')) {
    embroideryDataSize = 'L'
  } else if (embroideryData.size.includes('one-size')) {
    embroideryDataSize = 'os'
  }
  
  embroideryEnabled.value = `Text: ${embroideryData.text} | Font: ${embroideryData.font} | Size: ${embroideryDataSize} | Color: ${embroideryData.color}`;
  // embroideryText.value = embroideryData.text;
  // embroideryFont.value = embroideryData.font;
  // embroiderySize.value = embroideryDataSize;
  // embroideryColor.value = embroideryData.color;
  // embroideryLocation.value = embroideryData.location;
}

function addEmbroideryProductToCart() {
  // Get the embroidery product variant ID from the button
  const embroideryButton = document.querySelector('.embroidery-cta-title');
  if (!embroideryButton) {
    console.error('Embroidery button not found');
    return;
  }
  
  const embroideryVariantId = embroideryButton.getAttribute('data-embroidery-variant-id');
  if (!embroideryVariantId) {
    console.error('Embroidery variant ID not found');
    return;
  }
  
  // Add embroidery product to cart with properties to identify it
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: embroideryVariantId,
      quantity: 1,
      properties: {
        '_embroidery_addon': 'true',
        '_main_product_id': getMainProductId()
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    // console.log('Embroidery product added to cart:', data);
    // Store embroidery item keys for reference
    storeEmbroideryItemKeys();
    // Trigger cart update event
    document.dispatchEvent(new CustomEvent('cart:updated'));
  })
  .catch(error => {
    console.error('Error adding embroidery product to cart:', error);
  });
}

function getMainProductId() {
  // Get the main product variant ID from the form
  const mainProductInput = document.querySelector('input[name="id"]');
  return mainProductInput ? mainProductInput.value : null;
}

function updateEmbroideryDisplay(embroideryData) {
  const embroideryCta = document.querySelector('.embroidery-cta');
  document.querySelector('.embroidery-cta-title').style.display = 'none';
  if (!embroideryCta) return;
  if(embroideryData.font != 'circle_monogram') {
    //console.log('asdfasdfasdf', embroideryData.font);
  // Replace CTA with selected embroidery options display
    embroideryCta.innerHTML = `
      <div class="embroidery-selected">
        <!-- Top Component: Header with tickbox, title, price, edit and remove buttons -->
        <div class="embroidery-selected__header">
          <div class="embroidery-selected__header-left">
            <div class="embroidery-selected__checkbox">
              <input type="checkbox" checked disabled>
              <span class="checkmark">✓</span>
            </div>
            <span class="embroidery-selected__title">Embroidery:</span>
          </div>
          <div class="embroidery-selected__header-right">
            <span class="embroidery-selected__price">+ $16.00</span>
            <button type="button" class="embroidery-selected__edit" onclick="openEmbroideryModal()">
              Edit <span class="edit-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M13.8486 5.01712L11.3071 2.46886L12.7723 1L15.3139 3.54827L13.8486 5.01712Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.13037 14.7609L1.58887 12.2126L11.3072 2.46875L13.8487 5.01702L4.13037 14.7609Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.58888 12.2126L0.313965 16L4.13039 14.7609" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></span>
            </button>
            <div class="embroidery-selected__separator">|</div>
            <button type="button" class="embroidery-selected__remove" onclick="removeEmbroidery()">
              Delete <span class="delete-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <g clip-path="url(#clip0_634_1359)">
      <path d="M12.9516 4.48733H12.4193L11.7154 16H1.78534L1.08145 4.48733H0.548407C0.383849 4.48733 0.25 4.34249 0.25 4.16443V3.33035C0.25 2.54058 0.843664 1.89819 1.57354 1.89819H3.93639C4.05449 0.830671 4.89539 0 5.91344 0H7.58578C8.60382 0 9.44551 0.830671 9.56282 1.89819H11.9257C12.6563 1.89819 13.25 2.54058 13.25 3.33035V4.16443C13.25 4.34249 13.1161 4.48733 12.9516 4.48733ZM2.22941 15.4863H11.2706L11.943 4.48733H1.55779L2.23019 15.4863H2.22941ZM7.58656 0.51459H5.91422C5.15915 0.51459 4.53242 1.11608 4.41825 1.89904H9.08332C8.96837 1.11608 8.34242 0.51459 7.58735 0.51459H7.58656ZM12.7744 3.33035C12.7744 2.82428 12.3941 2.41278 11.9265 2.41278H1.57275C1.10507 2.41278 0.724774 2.82428 0.724774 3.33035V3.97359H12.7744V3.33035Z" fill="black"/>
      <path d="M8.9431 12.7234L6.74953 10.3507L4.55675 12.7234L4.22055 12.3605L6.41412 9.98689L4.22055 7.6133L4.55675 7.24951L6.74953 9.6231L8.9431 7.24951L9.2793 7.6133L7.08573 9.98689L9.2793 12.3605L8.9431 12.7234Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_634_1359">
        <rect width="13" height="16" fill="white" transform="matrix(-1 0 0 1 13.25 0)"/>
      </clipPath>
    </defs>
  </svg></span>
            </button>
          </div>
        </div>
        
        <!-- Middle Component: Preview and details -->
        <div class="embroidery-selected__middle">
          <div class="embroidery-selected__preview">
            <div class="embroidery-preview-text" id="embroidery-preview-text-selected">${embroideryData.text}</div>
          </div>
          <div class="embroidery-selected__details">
            <div class="embroidery-detail">Font Type: ${formatFontName(embroideryData.font.replace('_', '-'))}</div>
            <div class="embroidery-detail">Text: ${embroideryData.text}</div>
            <div class="embroidery-detail">Embroidery Size: ${embroideryData.font_size}</div>
            <div class="embroidery-detail">Text Color: ${embroideryData.color}</div>
          </div>
        </div>
        
        <!-- Bottom Component: Shipping note -->
        <div class="embroidery-selected__shipping">
          <div class="shipping-note">${embroideryData.shippingNote}</div>
        </div>
      </div>
    `;
  }
  else {
  //console.log('qwerqwerqwer', embroideryData.font);
    
    const textInputValue = embroideryData.text;
    const firstLetter =  textInputValue.charAt(0);
    const middleLetter =  textInputValue.slice(1, textInputValue.length - 1);
    const lastLetter =  textInputValue.charAt(textInputValue.length - 1);

    embroideryCta.innerHTML = `
      <div class="embroidery-selected">
        <!-- Top Component: Header with tickbox, title, price, edit and remove buttons -->
        <div class="embroidery-selected__header">
          <div class="embroidery-selected__header-left">
            <div class="embroidery-selected__checkbox">
              <input type="checkbox" checked disabled>
              <span class="checkmark">✓</span>
            </div>
            <span class="embroidery-selected__title">Embroidery:</span>
          </div>
          <div class="embroidery-selected__header-right">
            <span class="embroidery-selected__price">+ $16.00</span>
            <button type="button" class="embroidery-selected__edit" onclick="openEmbroideryModal()">
              Edit <span class="edit-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path d="M13.8486 5.01712L11.3071 2.46886L12.7723 1L15.3139 3.54827L13.8486 5.01712Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.13037 14.7609L1.58887 12.2126L11.3072 2.46875L13.8487 5.01702L4.13037 14.7609Z" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.58888 12.2126L0.313965 16L4.13039 14.7609" stroke="black" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg></span>
            </button>
            <div class="embroidery-selected__separator">|</div>
            <button type="button" class="embroidery-selected__remove" onclick="removeEmbroidery()">
              Delete <span class="delete-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <g clip-path="url(#clip0_634_1359)">
      <path d="M12.9516 4.48733H12.4193L11.7154 16H1.78534L1.08145 4.48733H0.548407C0.383849 4.48733 0.25 4.34249 0.25 4.16443V3.33035C0.25 2.54058 0.843664 1.89819 1.57354 1.89819H3.93639C4.05449 0.830671 4.89539 0 5.91344 0H7.58578C8.60382 0 9.44551 0.830671 9.56282 1.89819H11.9257C12.6563 1.89819 13.25 2.54058 13.25 3.33035V4.16443C13.25 4.34249 13.1161 4.48733 12.9516 4.48733ZM2.22941 15.4863H11.2706L11.943 4.48733H1.55779L2.23019 15.4863H2.22941ZM7.58656 0.51459H5.91422C5.15915 0.51459 4.53242 1.11608 4.41825 1.89904H9.08332C8.96837 1.11608 8.34242 0.51459 7.58735 0.51459H7.58656ZM12.7744 3.33035C12.7744 2.82428 12.3941 2.41278 11.9265 2.41278H1.57275C1.10507 2.41278 0.724774 2.82428 0.724774 3.33035V3.97359H12.7744V3.33035Z" fill="black"/>
      <path d="M8.9431 12.7234L6.74953 10.3507L4.55675 12.7234L4.22055 12.3605L6.41412 9.98689L4.22055 7.6133L4.55675 7.24951L6.74953 9.6231L8.9431 7.24951L9.2793 7.6133L7.08573 9.98689L9.2793 12.3605L8.9431 12.7234Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_634_1359">
        <rect width="13" height="16" fill="white" transform="matrix(-1 0 0 1 13.25 0)"/>
      </clipPath>
    </defs>
  </svg></span>
            </button>
          </div>
        </div>
        
        <!-- Middle Component: Preview and details -->
        <div class="embroidery-selected__middle">
          <div class="embroidery-selected__preview">
            <div class="embroidery-preview-text circle-monogram" id="embroidery-preview-text-selected">
              <span style="font-family: 'Circle Monogram First'">${firstLetter}</span>
              <span style="font-family: 'Circle Monogram Middle'">${middleLetter}</span>
              <span style="font-family: 'Circle Monogram Last'">${lastLetter}</span>
            </div>
          </div>
          <div class="embroidery-selected__details">
            <div class="embroidery-detail">Font Type: ${formatFontName(embroideryData.font.replace('_', '-'))}</div>
            <div class="embroidery-detail">Text: ${embroideryData.text}</div>
            <div class="embroidery-detail">Embroidery Size: ${embroideryData.font_size}</div>
            <div class="embroidery-detail">Text Color: ${embroideryData.color}</div>
          </div>
        </div>
        
        <!-- Bottom Component: Shipping note -->
        <div class="embroidery-selected__shipping">
          <div class="shipping-note">${embroideryData.shippingNote}</div>
        </div>
      </div>
    `;
  }
}

window.removeEmbroidery = function() {
  // Clear embroidery properties
  const embroideryEnabled = document.getElementById('embroidery-enabled');
  // const embroideryInput = document.getElementById('embroidery-properties');
  // const embroideryText = document.getElementById('embroidery-text');
  // const embroideryFont = document.getElementById('embroidery-font');
  // const embroiderySize = document.getElementById('embroidery-size');
  // const embroideryColor = document.getElementById('embroidery-color');
  // const embroideryLocation = document.getElementById('embroidery-location');

  if (embroideryEnabled) {
    embroideryEnabled.value = '';
  }
  // if (embroideryText) {
  //   embroideryText.value = '';
  // }
  // if (embroideryFont) {
  //   embroideryFont.value = '';
  // }
  // if (embroiderySize) {
  //   embroiderySize.value = '';
  // }
  // if (embroideryColor) {
  //   embroideryColor.value = '';
  // }
  // if (embroideryLocation) {
  //   embroideryLocation.value = '';
  // }

  document.querySelector('.embroidery-cta-title').style.display = 'block';
  
  // Reset to CTA button
  const embroideryCta = document.querySelector('.embroidery-cta');
  if (embroideryCta) {
    embroideryCta.innerHTML = `
      <button type="button" class="embroidery-button" data-embroidery-product-id="${ embroidery_product_id }" onclick="openEmbroideryModal()">
        <span class="embroidery-button__text">ADD EMBROIDERY</span>
        <span class="embroidery-button__price">From ${embroidery_product_price}</span>
        <span class="embroidery-button__arrow">></span>
      </button>
    `;
  }
  
  // Toggle add to cart buttons
  toggleAddToCartButtons();
  
  // Remove embroidery product from cart if it exists
  // This would require additional cart management logic
  //console.log('Embroidery removed');
}

// Function to remove embroidery products from cart
function removeEmbroideryFromCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const embroideryItems = cart.items.filter(item => 
        item.properties && item.properties._embroidery_addon === 'true'
      );
      
      if (embroideryItems.length > 0) {
        const updates = {};
        embroideryItems.forEach(item => {
          updates[item.key] = 0;
        });
        
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
      }
    })
    .then(response => {
      if (response) {
        return response.json();
      }
    })
    .then(data => {
      if (data) {
        //console.log('Embroidery products removed from cart');
        // Trigger multiple cart update events to ensure all components update
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:change'));
        
        // Also try to refresh cart drawer if it exists
        if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') {
          window.cartDrawer.refresh();
        }
        
        // Hide embroidery items immediately
        hideEmbroideryInCart();
      }
    })
    .catch(error => {
      console.error('Error removing embroidery products:', error);
    });
}

// Function to hide embroidery products in cart displays
function hideEmbroideryInCart() {
  // Add CSS to hide embroidery products
  const existingStyle = document.getElementById('embroidery-cart-hide-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  const style = document.createElement('style');
  style.id = 'embroidery-cart-hide-style';
  style.textContent = `
    /* Hide embroidery products in cart */
    .cart-item[data-embroidery-addon="true"],
    .cart-drawer-item[data-embroidery-addon="true"],
    .cart__item[data-embroidery-addon="true"],
    [data-cart-item][data-embroidery-addon="true"],
    .cart__line-item[data-embroidery-addon="true"],
    .cart-item[data-embroidery-addon="true"] *,
    .cart-drawer-item[data-embroidery-addon="true"] *,
    .cart__item[data-embroidery-addon="true"] *,
    [data-cart-item][data-embroidery-addon="true"] *,
    .cart__line-item[data-embroidery-addon="true"] * {
      display: none !important;
    }
    
    /* Hide embroidery products in cart totals */
    .cart-item[data-embroidery-addon="true"] + .cart-item__subtotal,
    .cart-drawer-item[data-embroidery-addon="true"] + .cart-item__subtotal,
    .cart__item[data-embroidery-addon="true"] + .cart-item__subtotal,
    [data-cart-item][data-embroidery-addon="true"] + .cart-item__subtotal,
    .cart__line-item[data-embroidery-addon="true"] + .cart-item__subtotal {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
  // Also hide by checking cart items directly
  setTimeout(() => {
    const cartItems = document.querySelectorAll('[data-cart-item], .cart-item, .cart-drawer-item, .cart__item, .cart__line-item');
    cartItems.forEach(item => {
      const itemKey = item.getAttribute('data-cart-item') || item.getAttribute('data-key');
      if (itemKey) {
        // Check if this is an embroidery item by looking for the property
        const embroideryIndicator = item.querySelector('[data-embroidery-addon]') || 
                                  item.querySelector('.embroidery-addon-indicator') ||
                                  (item.textContent && item.textContent.includes('embroidery'));
        
        if (embroideryIndicator || isEmbroideryItem(itemKey)) {
          item.style.display = 'none';
          item.setAttribute('data-embroidery-addon', 'true');
        }
      }
    });
  }, 100);
}

// Function to check if an item is an embroidery add-on
function isEmbroideryItem(itemKey) {
  // Check if we have stored embroidery items
  if (window.embroideryItems && window.embroideryItems.includes(itemKey)) {
    return true;
  }
  return false;
}

// Function to store embroidery item keys for reference
function storeEmbroideryItemKeys() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const embroideryItems = cart.items
        .filter(item => item.properties && item.properties._embroidery_addon === 'true')
        .map(item => item.key);
      
      window.embroideryItems = embroideryItems;
      //console.log('Stored embroidery item keys:', embroideryItems);
      
      
      
    })
    .catch(error => {
      console.error('Error storing embroidery item keys:', error);
    });
}


// Function to toggle between normal and embroidery add to cart buttons
function toggleAddToCartButtons() {
  const embroideryEnabled = document.getElementById('embroidery-enabled');
  // const embroideryInput = document.getElementById('embroidery-properties');
  // const embroideryText = document.getElementById('embroidery-text');
  // const embroideryFont = document.getElementById('embroidery-font');
  // const embroiderySize = document.getElementById('embroidery-size');
  // const embroideryColor = document.getElementById('embroidery-color');
  // const embroideryLocation = document.getElementById('embroidery-location');
  
  const hasEmbroidery = embroideryEnabled && embroideryEnabled.value && embroideryEnabled.value.trim() !== '';
  // const hasEmbroidery = embroideryInput && embroideryInput.value && embroideryInput.value.trim() !== '';
  // const hasEmbroideryText = embroideryText && embroideryText.value && embroideryText.value.trim() !== '';
  // const hasEmbroideryFont = embroideryFont && embroideryFont.value && embroideryFont.value.trim() !== '';
  // const hasEmbroiderySize = embroiderySize && embroiderySize.value && embroiderySize.value.trim() !== '';
  // const hasEmbroideryColor = embroideryColor && embroideryColor.value && embroideryColor.value.trim() !== '';
  // const hasEmbroideryLocation = embroideryLocation && embroideryLocation.value && embroideryLocation.value.trim() !== '';
  
  const normalButton = document.querySelector('[data-add-to-cart]:not(.atc-embroidery-button)');
  const embroideryButton = document.querySelector('.atc-embroidery-button');
  
  if (normalButton && embroideryButton) {
    if (hasEmbroidery) {
      // Hide normal button, show embroidery button
      normalButton.style.display = 'none';
      embroideryButton.style.display = 'block';
    } else {
      // Show normal button, hide embroidery button
      normalButton.style.display = 'block';
      embroideryButton.style.display = 'none';
    }
  }
}

// Function to handle embroidery button click
function handleEmbroideryButtonClick(event) {
  event.preventDefault();
  
  const button = event.currentTarget;
  const form = button.closest('form');
  
  if (!form) {
    console.error('Form not found for embroidery button');
    return;
  }
  
  // Validate form
  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }
  
  // Get embroidery product variant ID
  const embroideryButton = document.querySelector('.embroidery-cta-title');
  if (!embroideryButton) {
    console.error('Embroidery button not found');
    return;
  }
  
  const embroideryVariantId = embroideryButton.getAttribute('data-embroidery-variant-id');
  if (!embroideryVariantId) {
    console.error('Embroidery variant ID not found');
    return;
  }
  
  // Get main product variant ID
  const formData = new FormData(form);
  const mainProductVariantId = formData.get('id');
  if (!mainProductVariantId) {
    console.error('Main product variant ID not found');
    return;
  }
  
  // Show loading state
  button.classList.add('is-loading');
  button.disabled = true;
  
  // First, add embroidery product to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: embroideryVariantId,
      quantity: 1,
      properties: {
        '_embroidery_addon': 'true',
        '_main_product_id': mainProductVariantId
      }
    })
  })
  .then(response => response.json())
  .then(embroideryResponse => {
    if (embroideryResponse.status) {
      console.error('Failed to add embroidery product:', embroideryResponse);
      button.classList.remove('is-loading');
      button.disabled = false;
      return;
    }
    
    //console.log('Embroidery product added to cart:', embroideryResponse);
    
    // Store embroidery item keys for reference (if function exists)
    if (typeof storeEmbroideryItemKeys === 'function') {
      storeEmbroideryItemKeys();
    }
    
    // Trigger cart update event
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    // Now trigger the normal submit button click to handle main product
    const normalSubmitButton = form.querySelector('[data-add-to-cart]:not(.atc-embroidery-button)');
    if (normalSubmitButton) {
      // Remove loading state from embroidery button
      button.classList.remove('is-loading');
      button.disabled = false;
      
      // Trigger the normal submit button click
      normalSubmitButton.click();
    } else {
      console.error('Normal submit button not found');
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  })
  .catch(error => {
    console.error('Error adding embroidery product:', error);
    button.classList.remove('is-loading');
    button.disabled = false;
  });
}
// Event listeners
document.addEventListener('DOMContentLoaded', function() {
  const textInput = document.getElementById('embroidery-text-input');
  const fontInputs = document.querySelectorAll('input[name="font-type"]');
  const colorInputs = document.querySelectorAll('input[name="text-color"]');
  const sizeInputs = document.querySelectorAll('input[name="embroidery-size"]');

  const ensureSelection = (input, start, end) => {
    if (typeof start === 'number' && typeof end === 'number' && input === document.activeElement) {
      input.setSelectionRange(start, end);
    }
  };

  const applyUppercaseForSelectedFont = () => {
    if (!textInput) return;

    updateTextInputFontClass();

    if (selectedFontRequiresUppercase()) {
      const start = textInput.selectionStart;
      const end = textInput.selectionEnd;
      const uppercased = textInput.value.toUpperCase();
      if (uppercased !== textInput.value) {
        textInput.value = uppercased;
      }
      embroideryDisplayedValue = textInput.value;
      ensureSelection(textInput, start, end);
    } else if (selectedFontRequiresSecondLetterUppercase()) {
      const chars = textInput.value.split('')
      if (chars[0]) chars[0] = chars[0].toLowerCase();
      if (chars[1]) chars[1] = chars[1].toUpperCase();
      if (chars[2]) chars[2] = chars[2].toLowerCase();      

      textInput.value = chars.join('');      
    } else {
      textInput.value = embroideryRawInputValue;
      embroideryDisplayedValue = textInput.value;
    }

    toggleAddToCartButtons();
    updateCharacterCount();
    updateAddButton();
  };

  const diffStrings = (previous, current) => {
    if (previous === current) {
      return { start: current.length, removedLength: 0, addedText: '' };
    }

    let start = 0;
    while (start < previous.length && start < current.length && previous[start] === current[start]) {
      start++;
    }

    let prevEnd = previous.length - 1;
    let currEnd = current.length - 1;
    while (prevEnd >= start && currEnd >= start && previous[prevEnd] === current[currEnd]) {
      prevEnd--;
      currEnd--;
    }

    const removedLength = prevEnd >= start ? prevEnd - start + 1 : 0;
    const addedText = currEnd >= start ? current.slice(start, currEnd + 1) : '';

    return { start, removedLength, addedText };
  };

  if (textInput) {
    embroideryRawInputValue = textInput.value;
    embroideryDisplayedValue = textInput.value;

    textInput.addEventListener('input', function() {
      const currentValue = textInput.value;
      const { start, removedLength, addedText } = diffStrings(embroideryDisplayedValue, currentValue);

      embroideryRawInputValue = embroideryRawInputValue.slice(0, start) +
        addedText +
        embroideryRawInputValue.slice(start + removedLength);

      embroideryDisplayedValue = currentValue;

      if (selectedFontRequiresUppercase()) {
        const startPos = textInput.selectionStart;
        const endPos = textInput.selectionEnd;
        const uppercasedCurrent = currentValue.toUpperCase();
        if (uppercasedCurrent !== currentValue) {
          textInput.value = uppercasedCurrent;
          embroideryDisplayedValue = uppercasedCurrent;
          ensureSelection(textInput, startPos, endPos);
        }
      } else if (selectedFontRequiresSecondLetterUppercase()) {
        const chars = textInput.value.split('')
        if (chars[0]) chars[0] = chars[0].toLowerCase();
        if (chars[1]) chars[1] = chars[1].toUpperCase();
        if (chars[2]) chars[2] = chars[2].toLowerCase();      

        textInput.value = chars.join('');      
      } else {
        embroideryRawInputValue = textInput.value;
      }

      updatePreview();
      updateCharacterCount();
      updateAddButton();
      toggleAddToCartButtons(); // Toggle buttons when text changes
      updateTextInputFontClass();
    });

    applyUppercaseForSelectedFont();
  }
  
  fontInputs.forEach(input => {
    input.addEventListener('change', function() {
      applyUppercaseForSelectedFont();
      updatePreview();
    });
  });
  
  colorInputs.forEach(input => {
    input.addEventListener('change', updatePreview);
  });
  
  sizeInputs.forEach(input => {
    input.addEventListener('change', updatePreview);
  });
  
  // Initialize preview on load
  updatePreview();
  updateCharacterCount();
  updateAddButton();
  
  // Initialize button toggle
  toggleAddToCartButtons();
  
  // Add event listener to embroidery button
  const embroideryButton = document.querySelector('.atc-embroidery-button');
  if (embroideryButton) {
    embroideryButton.addEventListener('click', handleEmbroideryButtonClick);
  }
  
  // Initialize embroidery property displays
  // updateEmbroideryPropertyDisplays();
  
  // Hide embroidery products in cart
  hideEmbroideryInCart();
  
  // Store embroidery item keys for reference
  storeEmbroideryItemKeys();
  
  // Listen for cart updates to hide embroidery products
  document.addEventListener('cart:updated', function() {
    hideEmbroideryInCart();
  });
  
  document.addEventListener('cart:refresh', function() {
    hideEmbroideryInCart();
  });
  
  document.addEventListener('cart:change', function() {
    hideEmbroideryInCart();
  });
  
  // Listen for main product removal with multiple selectors
  document.addEventListener('click', function(e) {
    // Check various cart remove button selectors
    const removeButton = e.target.matches('[data-cart-remove]') || 
                        e.target.matches('.cart-remove') ||
                        e.target.matches('.cart__remove') ||
                        e.target.matches('[data-cart-item-remove]') ||
                        e.target.closest('[data-cart-remove]') ||
                        e.target.closest('.cart-remove') ||
                        e.target.closest('.cart__remove') ||
                        e.target.closest('[data-cart-item-remove]');
    
    if (removeButton) {
      // Check if main product is being removed
      const cartItem = e.target.closest('[data-cart-item]') || 
                      e.target.closest('.cart-item') ||
                      e.target.closest('.cart__item') ||
                      e.target.closest('[data-cart-line-item]');
      
      if (cartItem && !cartItem.hasAttribute('data-embroidery-addon')) {
        // Main product is being removed, remove embroidery products
        console.log('Main product being removed, cleaning up embroidery products');
        setTimeout(removeEmbroideryFromCart, 200);
      }
    }
  });
  
  // Also listen for cart drawer specific events
  document.addEventListener('cart:drawer:updated', function() {
    hideEmbroideryInCart();
  });
  
  // Listen for any cart-related mutations
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const hasCartItems = addedNodes.some(node => 
          node.nodeType === 1 && (
            node.matches && (
              node.matches('[data-cart-item]') ||
              node.matches('.cart-item') ||
              node.matches('.cart__item') ||
              node.querySelector('[data-cart-item]') ||
              node.querySelector('.cart-item') ||
              node.querySelector('.cart__item')
            )
          )
        );
        
        if (hasCartItems) {
          setTimeout(hideEmbroideryInCart, 100);
        }
      }
    });
  });
  
  // Start observing cart containers
  const cartContainers = document.querySelectorAll('[data-cart-drawer], .cart-drawer, .cart, [data-cart]');
  cartContainers.forEach(container => {
    cartObserver.observe(container, { childList: true, subtree: true });
  });
});
